import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-blog-block',
  templateUrl: './skeleton-blog-block.component.html',
  styleUrls: ['./skeleton-blog-block.component.scss'],
  standalone: false
})
export class SkeletonBlogBlockComponent {}
